import { convertObjectPropsToSnakeCase } from "./utils";
const WEBSOCKET_PROTOCOL = "gitlab-agent-watch-api";
export var WatchEvent;
(function (WatchEvent) {
    WatchEvent["ADDED"] = "ADDED";
    WatchEvent["MODIFIED"] = "MODIFIED";
    WatchEvent["DELETED"] = "DELETED";
})(WatchEvent || (WatchEvent = {}));
export var EventType;
(function (EventType) {
    EventType["DATA"] = "data";
    EventType["ERROR"] = "error";
})(EventType || (EventType = {}));
const WATCH_EVENT_TYPES = Object.freeze([
    WatchEvent.ADDED,
    WatchEvent.MODIFIED,
    WatchEvent.DELETED,
]);
const EVENT_STRINGS = Object.freeze([EventType.DATA, EventType.ERROR]);
export class WebSocketWatchManager {
    constructor() {
        this.websocket = null;
        this.connectionPromise = null;
        this.listeners = {};
        this.watchStreams = {};
    }
    createSocketUrl({ basePath, headers, }) {
        const baseUrl = basePath.replace("https://", "");
        const agentId = headers["GitLab-Agent-Id"];
        const token = headers["X-CSRF-Token"];
        return `wss://${baseUrl}/watch?gitlab-csrf-token=${token}&gitlab-agent-id=${agentId}`;
    }
    handleWatchEvent(data) {
        var _a, _b, _c;
        const { watchEvent, watchId } = data;
        const eventType = watchEvent === null || watchEvent === void 0 ? void 0 : watchEvent.type;
        const eventData = watchEvent === null || watchEvent === void 0 ? void 0 : watchEvent.object;
        const stream = this.watchStreams[watchId];
        if (!stream)
            return;
        const index = stream.findIndex((resource) => { var _a, _b; return ((_a = resource === null || resource === void 0 ? void 0 : resource.metadata) === null || _a === void 0 ? void 0 : _a.uid) === ((_b = eventData === null || eventData === void 0 ? void 0 : eventData.metadata) === null || _b === void 0 ? void 0 : _b.uid); });
        switch (eventType) {
            case WatchEvent.ADDED:
                stream.push(eventData);
                break;
            case WatchEvent.MODIFIED:
                if (index >= 0)
                    stream[index] = eventData;
                break;
            case WatchEvent.DELETED:
                if (index >= 0)
                    stream.splice(index, 1);
                break;
            default:
                this.emit(watchId, EventType.ERROR, {
                    eventType: eventType || data.type,
                    message: ((_b = (_a = data.error) === null || _a === void 0 ? void 0 : _a.object) === null || _b === void 0 ? void 0 : _b.message) || ((_c = data.error) === null || _c === void 0 ? void 0 : _c.message),
                });
        }
        this.emit(watchId, EventType.DATA, stream);
    }
    receiveMessage(event) {
        const data = JSON.parse(event.data);
        if (!data)
            return;
        const watchId = data.watchId;
        if (this.watchStreams[watchId]) {
            this.handleWatchEvent(data);
        }
    }
    clearWebsocket() {
        this.websocket = null;
        this.connectionPromise = null;
    }
    async connectToWebsocket(configuration) {
        if (this.connectionPromise)
            return this.connectionPromise;
        this.connectionPromise = new Promise((resolve, reject) => {
            const socketUrl = this.createSocketUrl(configuration);
            this.websocket = new WebSocket(socketUrl, WEBSOCKET_PROTOCOL);
            this.websocket.onclose = () => this.clearWebsocket();
            this.websocket.onmessage = (event) => this.receiveMessage(event);
            this.websocket.onopen = () => resolve(this.websocket);
            this.websocket.onerror = (event) => {
                this.clearWebsocket();
                reject(event);
            };
        });
        return this.connectionPromise;
    }
    async initConnection({ message, configuration, }) {
        this.watchStreams[message.watchId] =
            this.watchStreams[message.watchId] || [];
        const socket = await this.connectToWebsocket(configuration);
        const socketMessage = convertObjectPropsToSnakeCase(message);
        socket.send(JSON.stringify({
            type: "watch",
            ...socketMessage,
        }));
        return this;
    }
    on(eventName, watchId, callback) {
        this.listeners[watchId] = this.listeners[watchId] || {};
        this.listeners[watchId][eventName] =
            this.listeners[watchId][eventName] || [];
        this.listeners[watchId][eventName].push(callback);
    }
    off(eventName, watchId, callback) {
        var _a;
        const listeners = (_a = this.listeners[watchId]) === null || _a === void 0 ? void 0 : _a[eventName];
        if (!listeners)
            return;
        const index = listeners.indexOf(callback);
        if (index !== -1) {
            listeners.splice(index, 1);
        }
    }
    emit(watchId, eventName, eventData) {
        var _a;
        const listeners = (_a = this.listeners[watchId]) === null || _a === void 0 ? void 0 : _a[eventName];
        listeners === null || listeners === void 0 ? void 0 : listeners.forEach((listener) => listener(eventData));
    }
}
export const webSocketWatchManager = new WebSocketWatchManager();
